<div>
  <div [formGroup]="form">
    <mat-form-field>
      <mat-label>Год</mat-label>
      <mat-select formControlName="year">
        <mat-option *ngFor="let option of years | async" [value]="option">
          {{option}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div class="input-group">
      <div *ngIf="form.controls.ratings.value.length > 0 else noSelectedRef">
        Выбранные рейтинги:
        <b>{{form.value.ratings.length ? form.value.ratings[0]['short_name'] : ''}}
        <span *ngIf="form.value.ratings?.length > 1">и ещё {{form.value.ratings.length - 1}}</span></b>
      </div>
      <ng-template #noSelectedRef><div>Рейтинги не выбраны</div></ng-template>
    </div>

    <div class="input-group">
      <button mat-raised-button
              color="primary"
              (click)="selectRatings()">Выбрать рейтинги</button>
    </div>

    <div class="flex" id="min_count_input">
      Не менее чем в
      <mat-form-field>
         <input matInput type="number" formControlName="count" autocomplete="false" min="1" [max]="form.value.ratings.length || 1">
      </mat-form-field>
      рейтингах.
    </div>

    <div class="input-group">
      <mat-label>Ранг</mat-label>
      <ngx-slider [options]="rangeOptions" formControlName="range" [manualRefresh]="rangeRefresh"></ngx-slider>
    </div>

  </div>
  <div>
    <div class="button_wrap" [matTooltip]="form.value.ratings.length > 0 ? (form.value.ratings.length < form.value.count ? 'Для сохранения уменьшите количество рейтингов, в которых присутствуют вузы' : '') : 'Для сохранения выберите хотя бы один рейтинг'">
      <button mat-raised-button
              color="primary"
              [disabled]="form.invalid || this.form.value.ratings.length == 0"
              (click)="complete()">{{ buttonLabel }}
      </button>
    </div>
  </div>
</div>
